module.exports = __webpack_public_path__ + "img/nav-right-expand-search-toyota.5b40e545.png";